import { render, staticRenderFns } from "./BioTransfer.vue?vue&type=template&id=4f9a862a&scoped=true"
import script from "./BioTransfer.vue?vue&type=script&lang=js"
export * from "./BioTransfer.vue?vue&type=script&lang=js"
import style0 from "./BioTransfer.vue?vue&type=style&index=0&id=4f9a862a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9a862a",
  null
  
)

export default component.exports